import type { ReactNode } from 'react';
import { ChevronBand, Halftone, Label, Paper } from '../design/Paper';
import { Tracker } from '../design/Tracker';
import { ro } from '../i18n/ro';

/** The phone chrome: app mark and the always-visible failed-election tracker. */
export function PhoneFrame({
  failedElections,
  children,
}: {
  failedElections: number;
  children: ReactNode;
}) {
  return (
    <Paper className="flex min-h-full flex-col" vignette={false}>
      <header className="relative shrink-0 bg-ink px-4 py-3 text-paper">
        <Halftone className="text-paper" />
        <div className="relative flex items-center justify-between gap-3">
          <Label className="text-[0.6rem] opacity-70">{ro.appName}</Label>
          <Tracker
            failedElections={failedElections}
            size="sm"
            className="[&_span]:text-paper/70"
          />
        </div>
      </header>
      <ChevronBand className="shrink-0 text-ink" />
      {children}
    </Paper>
  );
}
